import { WidgetTypeInterface } from "..";

export function createWidget(widget: WidgetTypeInterface) {
  return widget;
}
